import * as ContentGenres from '@api/content-genres';
import { ContextFormField, createCFF, createCFFTextAttr } from '@components/context-form-field';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import { FaImdb } from '@icon/react-icons';
import { useRequest } from '@lib/common';
import { Checkbox, Divider, FormControlLabel, Grid, TextField } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import { FilmingLocationField } from 'pages/deals/deal-form/filming-location-field';
import { DateControlledTextField } from 'pages/person-management/person-management-form/person-master-relation-form';
import { useCallback, useEffect, useState } from 'react';
import { Control, FieldValues, useController, useFormContext } from 'react-hook-form';
import { AdultContentField } from '../fields/content-adult-flag';
import { OriginCountryField } from '../fields/content-country.field';
import { ContentFundingStatusField } from '../fields/content-funding-status';
import { GenresTypeField } from '../fields/content-genres-type';
import { GenresField } from '../fields/content-genres.field';
import { ControlledAutoCompleteFieldForContentKeywords } from '../fields/content-keywords.field';
import { LanguageField } from '../fields/content-language.field';
import { ProductionDateField } from '../fields/content-production-year.field';
import { ContentStatusField } from '../fields/content-status.field';
import { DataOwnerField } from '../fields/data-owner-field';
import { VitrinaContentStatusField } from '../fields/vitrina-content-status.field';
import { DatePicker } from '@material-ui/pickers';
import { createControlField } from '@lib/common';
import { ReleaseDateField } from '../fields/content-release-date.field';

export const DateStartField = createControlField(props => (
  <DatePicker
    fullWidth
    style={{ marginTop: 0, marginBottom: 0 }}
    inputVariant="outlined"
    views={["month","year"]}
    label="Filming Start Date"
    helperText="Month/Year when filming will start."
    margin="normal"
    size="small"
    {...props}
  />
));
export const DateEndField = createControlField(props => (
  <DatePicker
    fullWidth
    style={{ marginTop: 0, marginBottom: 0 }}
    inputVariant="outlined"
    views={["month","year"]}
    label="Filming End Date"
    helperText="Month/Year when filming will end."
    margin="normal"
    size="small"
    {...props}
  />
));

export const AdditionalInfoContentSection = ({edit=false}) => {
  const { control } = useFormContext();
  const form = useFormContext();
  const genres = form.watch('genres_id');
    const content_status = form.watch('status');


  const { loading: logsLoading, result: genresMaster } = useRequest(
    () => ContentGenres.get(),
    []
  );
  
useEffect(() => { 
  if(content_status){
    const status = content_status?.name || content_status;
    form.setValue("vtr_content_status", status, { shouldValidate: true });
  }
}, [content_status, form]);

  useEffect(() => {
    if (genres && genres.length > 0) {
      const filterGenreCategory = genresMaster?.data.find(genre => genre.id == genres[0].id);
      const categoryValue = filterGenreCategory && filterGenreCategory.genre_catagory_name;
      if (categoryValue) {
        form.setValue('genre_category', categoryValue.toLowerCase());
      }
    } else {
      form.setValue('genre_category', "");
    }
  }, [genres]);

  const [checkedNotSureStartDate, setCheckedNotSureStartDate] = useState<boolean>(false);
  const [checkedNotSureEndDate, setCheckedNotSureEndDate] = useState<boolean>(false);

  useEffect(()=>{
    if(form.getValues("filming_start_date")){
      if(!isNaN(Date.parse(form.getValues("filming_start_date")))){
        setCheckedNotSureStartDate(false);
      }else{
        setCheckedNotSureStartDate(true);
      }
    }
  },[])

  useEffect(()=>{
    if(form.getValues("filming_end_date")){
      if(!isNaN(Date.parse(form.getValues("filming_end_date")))){
        setCheckedNotSureEndDate(false);
      }else{
        setCheckedNotSureEndDate(true);
      }
    }
  },[])

  return (
    <>
      <ScrollSectionTitle
        id="additional-details"
        subTitle="Additional information for the content."
        icon={<DescriptionRoundedIcon fontSize="large" style={{ color: amber[700] }} />}>
        Addtional Information
      </ScrollSectionTitle>
      <Divider />
      <br />
      <Grid container spacing={2}>
        {attributes.map((attr, idx) => (
          <Grid key={idx} item xs={4}>
            {typeof attr === 'function' ? attr(control) : <ContextFormField {...attr} />}
          </Grid>
        ))}
        <Grid item xs={8}>
          <GenresField control={control} name="genres_id" />
        </Grid>
        <Grid item xs={4}>
          <OriginCountryField control={control} name="origin_country" />
        </Grid>
        <Grid item xs={4}>
          <ContentStatusField control={control} name="status" />
        </Grid>
        <Grid item xs={4}>
          <VitrinaContentStatusField control={control} name="vtr_content_status" />
        </Grid>
        <Grid item xs={4}>
          <ReleaseDateField control={control} name="release_date"/>
        </Grid>
        <Grid item xs={4}>
          <ContextFormField
            name="source_url"
            label="Source Url"
            helperText="Source Url of the Content"
          />
        </Grid>
        <Grid item xs={4}>
          <ContextFormField
            name="source_name"
            label="Source Name"
            helperText="Source Name of the Content"
          />
        </Grid>
        <Grid item xs={7}>
          <ControlledAutoCompleteFieldForContentKeywords
            size="small"
            variant="outlined"
            name={'content_keywords'}
            label={'Content Keywords'}
            control={form.control}
          />
        </Grid>
        <Grid item xs={4}>
          <ContentFundingStatusField control={control} name="funding_status" />
        </Grid>
        <Grid item xs={4}>
          <ContextFormField label="Source" name="source_of_record" helperText="source of record" disabled />
        </Grid>
        <Grid item xs={4}>
          <ContextFormField label="TMDB Id" name="content_id" helperText="TMDB ID" />
        </Grid>

        <Grid item xs={4}>
          <ContextFormField label="ASIN" name="asin" helperText="ASIN ID" />
        </Grid>
        <Grid item xs={4}>
          <ContextFormField label="ISBN 13" name="isbn13" helperText="ISBN13 ID" />
        </Grid>
        <Grid item xs={4}>
          <ContextFormField label="ISBN 10" name="isbn10" helperText="ISBN10 ID" />
        </Grid>
        <Grid item xs={4}>
          <AdultContentField control={control} name="adult" />
        </Grid>
        <Grid item xs={4}>
          <DataOwnerField control={control} name="dataowner_id" />
        </Grid>
        <Grid item xs={4}>
          <GenresTypeField control={control} name="genre_category" />
        </Grid>
        <Grid item xs={4}>
          <FilmingLocationField control={control} name="filming_location" />
        </Grid>
        <Grid item xs={4}>
          <DateStartField control={control} name="filming_start_date"/>
        </Grid>
        <Grid item xs={4}>
          <DateEndField control={control} name="filming_end_date"/>
        </Grid>
        {edit && <><Grid item xs={3}>
          <DateControlledTextField
            disabled
            fullWidth
            variant="outlined"
            name={'created_at'}
            label={'Created At'}
            control={form.control}
            defaultValue={form.getValues("created_at") ?? ''}
          />
        </Grid>
        <Grid item xs={3}>
          <DateControlledTextField
            fullWidth
            disabled
            variant="outlined"
            name={'modified_at'}
            label={'Modified On'}
            control={form.control}
            defaultValue={form.getValues("modified_at") ?? ''}
          />
        </Grid>
        <Grid item xs={3}>
          <ControlledTextField
            fullWidth
            disabled
            variant="outlined"
            name={'updated_by'}
            label={'Modified By'}
            control={form.control}
            defaultValue={form.getValues("updated_by") ?? ''}
          />
        </Grid></>}
      </Grid>
    </>
  );
};
const ControlledTextField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });

  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  return <TextField {...props} name={name} value={value || ''} onChange={callbackOnChange} />;
};

const attributes = [
  (control: Control<FieldValues>) => <LanguageField control={control} name="language_id" />,

  createCFFTextAttr(
    'imdb_id',
    'IMDb ID',
    'Relative id in IMDb',
    <FaImdb
      style={{
        color: '#f3ce13',
        background:
          'radial-gradient(circle, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
      }}
    />
  ),
  createCFF({
    type: 'number',
    name: 'budget',
    helperText: 'The budget of the project. (Optional).',
    label: 'Budget',
    icon: '$',
  }),
];

const rev = createCFF({
  type: 'number',
  name: 'revenue',
  helperText: 'Total revenue of the project. (Optional).',
  label: 'Revenue',
  icon: '$',
});
